import * as H from "history";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import ApiService from "../../ApiService";
import LinkCard from "../../LinkCard";
import School from "../../../models/School";
import SchoolList from "../../SchoolList";
import { Link } from "react-router-dom";
import { CommandBarButton } from "office-ui-fabric-react";
import SchoolPageTitle from "../../SchoolPageTitle";
import AdminSchoolMenu from "../../AdminSchoolMenu";

interface ConfigureSchoolUIPageProps {
    tenantId: string;
    schoolCode: string;
    history: H.History;

    apiService: ApiService;
}

interface ConfigureSchoolUIPageState {
    school?: School;
}

class ConfigureSchoolUIPage extends Component<ConfigureSchoolUIPageProps & DispatchProps, ConfigureSchoolUIPageState> {

    constructor(props: ConfigureSchoolUIPageProps & DispatchProps) {
        super(props);

        this.state = {
            school: undefined
        };
    }

    async componentDidUpdate(prevProps: Readonly<ConfigureSchoolUIPageProps & DispatchProps>, prevState: Readonly<ConfigureSchoolUIPageState>, snapshot?: any): Promise<void> {
    }

    async componentDidMount() {
        if (this.props.tenantId && this.props.schoolCode) {
            const school = await this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode);
            this.setState({
                school: school
            });
        }

    }

    render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Configure" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <SchoolList title={this.state.school?.schoolName ? this.state.school.schoolName : ""} enableRowLinks={false} schools={this.state.school ? [this.state.school] : []}>
                    <Link to={`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/configure-advanced`}>
                        <CommandBarButton
                            iconProps={{ iconName: "CodeEdit" }}
                            text="Advanced"
                            onClick={() => { }}
                        />
                    </Link>
                </SchoolList>
                <div className={"flex-row"}>
                    <LinkCard title={"Subject Excludes"} to={`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/configure-subject-excludes`} iconName={"Blocked"} description={"Exclude Subjects"} />
                    <LinkCard title={"Subject Merges"} to={`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/configure-subject-merges`} iconName={"MergeDuplicate"} description={"Edit Subject Merges"} />
                    <LinkCard title={"Subject Renames"} to={`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/configure-subject-renames`} iconName={"Edit"} description={"Rename Subjects"} />
                </div>
                <div className={"flex-row"}>
                    <LinkCard title={"Year Groupings"} to={`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/configure-years`} iconName={"PageHeaderEdit"} description={"Change School Year groups"} />

                    <LinkCard title={"Assign Years"} to={`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/configure-assign-years`} iconName="DependencyAdd" description="Assign SDS Years To Year Grouping" />
                </div>
                <div className={"flex-row"}>
                    <LinkCard title={"School Theme"} to={`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/configure-theme`} iconName={"EditCreate"} description={"Change School Theme and Logo"} />
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): ConfigureSchoolUIPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId: tenantId,
            schoolCode: schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history,
        };
    }
)(ConfigureSchoolUIPage);